import React from 'react';
import LoginPage from '../pages/LoginPage';
import AuthMoldel from '../models/AuthMoldel';
import { Navigate } from 'react-router-dom';
import RegisterPage from '../pages/RegisterPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import NotFoundPage from '../pages/NotFoundPage';

const AuthGuard = () => {
  const isLoggedin = AuthMoldel.checkAuth();
  if (!isLoggedin) {
    return <Navigate to="/login" replace />;
  }
  return <NotFoundPage />;
};

const publics = [
	{ path: '/login', element: <LoginPage/> },
	{ path: '/register', element: <RegisterPage/> },
	{ path: '/forgot-password', element: <ForgotPasswordPage/> },
	{ path: '*', element: <AuthGuard /> },
];

export default publics;
